import { IIcon } from '../interfaces'

const SvgComponent = ({ width = 20, height = 20, size, ...props }: IIcon) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 21 20'
    width={size || width}
    height={size || height}
    {...props}
  >
    <path
      fill='currentColor'
      d='M10.24 14.679a.82.82 0 0 0 .603-.246.82.82 0 0 0 .246-.604.82.82 0 0 0-.246-.603.82.82 0 0 0-.603-.246.82.82 0 0 0-.603.247.82.82 0 0 0-.246.603.82.82 0 0 0 .246.603.82.82 0 0 0 .604.246m-.59-2.984h1.173q.016-.615.18-.983.165-.367.798-.975.55-.55.842-1.015t.292-1.1q0-1.076-.773-1.68-.773-.606-1.829-.606-1.043 0-1.727.557a3.14 3.14 0 0 0-.975 1.312l1.07.43a2.4 2.4 0 0 1 .521-.81q.368-.393 1.095-.393.739 0 1.092.405a1.324 1.324 0 0 1 .111 1.667 3.7 3.7 0 0 1-.616.682q-.82.74-1.037 1.18-.217.441-.217 1.33m.601 6.221a7.7 7.7 0 0 1-3.088-.623 8 8 0 0 1-2.514-1.692 8 8 0 0 1-1.692-2.513 7.7 7.7 0 0 1-.624-3.087q0-1.642.623-3.088A8 8 0 0 1 4.648 4.4a8 8 0 0 1 2.513-1.692 7.7 7.7 0 0 1 3.087-.624q1.643 0 3.088.623 1.444.624 2.514 1.692a8 8 0 0 1 1.693 2.513q.624 1.445.623 3.087a7.7 7.7 0 0 1-.623 3.088 8 8 0 0 1-1.692 2.514 8 8 0 0 1-2.513 1.693 7.7 7.7 0 0 1-3.087.623m-.001-1.25q2.79 0 4.729-1.937 1.937-1.937 1.937-4.73 0-2.79-1.937-4.728t-4.73-1.938q-2.79 0-4.728 1.938T3.583 10q0 2.79 1.938 4.729 1.937 1.937 4.729 1.937'
    />
  </svg>
)
export default SvgComponent
